import type { Icons } from '@eppendorf/vnls-css/dist';

const PARAMETER_ICONS = new Map<string, Icons>([
  ['temperature', 'temperature'],
  ['cabinet-temperature', 'temperature'],
  ['ambient-temperature', 'ambient-temperature'],
  ['relative-humidity', 'relative-humidity'],
  ['humidity', 'relative-humidity'],
  ['barometric-pressure', 'barometric-pressure'],
  ['brightness', 'brightness'],
  ['agitation', 'agitation'],
  ['co2-concentration', 'co2-concentration'],
  ['o2-concentration', 'o2-concentration'],
  ['photosynthetic-light', 'photosynthetic-light'],
  ['water-level', 'water-level'],
  ['co2-tank', 'co2-tank'],
  ['time', 'time'],
  ['speed', 'agitation'],
  ['mixer', 'agitation'],
  ['block', 'temperature'],
  ['lid', 'temperature'],
  ['battery', 'battery'],
  ['pressure', 'pressure'],
  ['light', 'light'],
  ['uv-light', 'uv-light'],
  ['offset', 'offset'],
  ['shaking-speed', 'shaking-speed'],
]);

export function parseBoolean(arg: string | undefined): boolean | undefined {
  if (arg?.toLowerCase?.() === 'false') return false;
  if (arg?.toLowerCase?.() === 'true') return true;
  return undefined;
}

export function getIconNameForParameterName(parameterName?: string): Icons {
  const name = parameterName?.normalize('NFKD').trim().toLowerCase().replace(/\s+/g, '-');
  if (!name) return 'placeholder';
  if (name.startsWith('temperature-(probe)')) return 'temperature';
  if (name.includes('timer')) return 'timer';
  return PARAMETER_ICONS.get(name) ?? 'placeholder';
}
